import React from "react";
import {
	EAnnex6V2RecordState,
	TAnnex6V2Record,
} from "redux/app/annex6-v2/@types";
import classNames from "classnames";

export type Annex6V2TableColumns = React.ReactNode[];
type OwnProps = {
	record: TAnnex6V2Record;
	tableRows: Annex6V2TableColumns[];
	theme?: "light" | "dark";
};
function Annex6V2TableRows(props: OwnProps) {
	const { record, tableRows, theme } = props;
	const userTheme = localStorage.getItem("theme") || "light";
	const resolvedTheme = theme ?? userTheme;
	const isStrikedOff = record.state === EAnnex6V2RecordState.STRIKED_OFF;
	return (
		<>
			{tableRows.map((tableRow, index) => {
				const isValidRow = tableRow.length === 4;
				if (!isValidRow) {
					console.error(
						"Invalid Annex6 Row format for:",
						record.recordCode,
						isValidRow,
						tableRow.length
					);
					return null;
				}
				const dateSection = tableRow[0];
				const codeSection = tableRow[1];
				const itemSection = tableRow[2];
				const remarksSection = tableRow[3];
				const isRemarksEmpty = remarksSection === "" || remarksSection === null;

				if (isRemarksEmpty) return null;

				return (
					<tr
						className={classNames("uppercase", {
							"line-through": isStrikedOff,
							"text-ws_input_flat_font": resolvedTheme === "dark",
						})}
						key={index}
					>
						<td className="relative">
							<div
								className={classNames(
									{
										"line-through": isStrikedOff,
										"text-ws_input_flat_font bg-ws_table_td_background":
											resolvedTheme === "dark",
										"bg-white": resolvedTheme === "light",
									},
									"p-3 m-px text-sm leading-7 text-left ws-marpol-td--divfix"
								)}
							>
								<div className="h-full">
									<span className="block font-medium whitespace-nowrap">
										{dateSection}
									</span>
								</div>
							</div>
						</td>
						<td className="relative">
							<div
								className={classNames(
									{
										"line-through": isStrikedOff,
										"text-ws_input_flat_font bg-ws_table_td_background":
											resolvedTheme === "dark",
										"text-gray-800 bg-white": resolvedTheme === "light",
									},
									"p-3 m-px text-sm font-medium leading-7 text-center ws-marpol-td--divfix"
								)}
							>
								{codeSection}
							</div>
						</td>
						<td className="relative">
							<div
								className={classNames(
									{
										"line-through": isStrikedOff,
										"text-ws_input_flat_font bg-ws_table_td_background":
											resolvedTheme === "dark",
										"text-gray-800 bg-white": resolvedTheme === "light",
									},
									"p-3 m-px text-sm font-medium leading-7 text-right ws-marpol-td--divfix"
								)}
							>
								<div className="h-full font-medium">{itemSection}</div>
							</div>
						</td>
						<td className="relative">
							<div
								className={classNames(
									{
										"text-ws_input_flat_font bg-ws_table_td_background":
											resolvedTheme === "dark",
										"text-gray-800 bg-white": resolvedTheme === "light",
									},
									"p-3 m-px text-sm font-medium leading-7 text-left"
								)}
							>
								<div className="font-medium uppercase">{remarksSection}</div>
							</div>
						</td>
					</tr>
				);
			})}
		</>
	);
}

export default Annex6V2TableRows;
